module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAUVBMVEUAAADN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uQeTzdfAAAAGnRSTlMA3hvzsCJv/axDdjkFTFUdFQ/W5IjEYOmZpZGiFL4AAAClSURBVBjTZZFZEsMgCEAxBosal+wZ7n/QqjRTM3lfzhMQECpoSHFBjQ5BSCN3jKm6QfMDXS0xRyuQxJZA5mUCwUgsyuEjsGCAmtTneTYp+aqkw49D5Ar1+ojB2hDj3Rtwz1vuW0i49XJJIMxOMShe92rtnNFLwxmIPWSnpUA3hZlgihdtHm6wFvTwREa6ZnnFH2H4r0674Ghtp9zsa8nP7yCDUPgCyagWsV5rOogAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_delegate.png
// module id = jpwx
// module chunks = 15